import { useState } from "react";
import YouTube, { YouTubeProps } from "react-youtube";

type YoutubeViewProps = {
    url: string,
    height?: string,
    width?: string,
    autoplay?: 0 | 1
}

export default function YouTubeView({ url, width, height, autoplay }: YoutubeViewProps) {
    const onPlayerReady: YouTubeProps['onReady'] = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    let link = ''

    if(url.includes('yout')){
        const split = url.split('/')
        link = split[split.length -1]
    }
    const [linkLimpo, setLink] = useState(link)

    const opts: YouTubeProps['opts'] = {
        height: height ? height : '390',
        width: width ? width : '640',
        playerVars: {
            autoplay: autoplay ? autoplay : 0,
        },
    };

    return (
        <>
            <div>
                <YouTube videoId={linkLimpo} opts={opts} onReady={onPlayerReady} />
            </div>
        </>
    )
}